import Skeleton from "react-loading-skeleton";
import { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';


const ListingsSkeleton = ({className}) => {
    const [breakpoint, setBreakpoint] = useState('desktop');
    
    const SKELETON_CONFIG = {
      '/': { desktop: 9, tablet: 12, mobile: 6 },
      'mylistings': { desktop: 6, tablet: 9, mobile: 6 },
      'myoffers': { desktop: 6, tablet: 4, mobile: 6 },
      'user': { desktop: 5, tablet: 4, mobile: 6 },
    }

    useEffect(() => {
        const updateSize = () => {
            const width = window.innerWidth;
            if (width < 640) setBreakpoint('mobile');
            else if (width < 1024) setBreakpoint('tablet');
            else setBreakpoint('desktop');
        };

        window.addEventListener('resize', updateSize);
        updateSize(); // Initial call
        return () => window.removeEventListener('resize', updateSize);
    }, []);

    const { pathname } = useLocation()
    const pathroot=pathname.split('/')[1]

    const config = SKELETON_CONFIG[pathroot] || SKELETON_CONFIG['/'];
    console.log(config)
    console.log(breakpoint)
    const count = config[breakpoint];
    console.log(count)
    console.log(className)

    return (
        <div className={className ? `${className} listings-grid` : "listings-grid"}>
            {Array.from({ length: count }).map((_, i) => (
                <div className="skeleton-listing-card" key={i}>
                    <Skeleton className="thumbnail-image"/>
                    <Skeleton count={3} width="50%"/>
                </div>
            ))}
        </div>
    )
}
export default ListingsSkeleton
